import { Component, h, State, Prop, Event, EventEmitter } from '@stencil/core';
import { Pollobj, Answerobj } from '../../model/index'
import { Questions, Data, PageAnswer } from '../../model/questions';
@Component({
  tag: 'component-poll',
  shadow: false
})

export class Poll {

  @Prop() name?: string;
  @Prop() country: string;
  @Prop() user?: string;
  @Prop() email?: string;
  @Prop() textsMap: Map<string, any>;

  @State() poll: Pollobj;
  @State() viewanswers: Answerobj;
  @State() idx = 0;
  @Prop() origin: string;
  @Prop() type: string;

  response: Questions;
  data: Data;
  id_prev_question = 1;
  listDisabledAnswers: Array<string> = [];

  hashMapQuestions = {};
  hashMapQuestionsAnswers = {};
  listquestion: Array<Questions> = [];
  pageAnswer: PageAnswer;
  progress = 0;

  @Event({
    eventName: "referencePoll",
    bubbles: false,
  }) referencePoll: EventEmitter<string>;

  async componentWillLoad() {
    this.poll = await fetch(`${process.env.SERVICES_API}/poll/${this.type}/${this.origin}/${this.country}`, {
      method: 'GET',
      headers: {
        'Authorization': `Basic ${process.env.SERVICES_TOKEN}`
      }
    })
      .then(response => response.json());
    this.viewanswers = this.poll;
    this.calculateProgress(1);
  }


  onNextQuestion(event: CustomEvent<PageAnswer>) {
    window.scrollTo(0, 0);
    this.pageAnswer = event.detail;
    //console.log(this.pageAnswer);
    this.response = Object.assign([], this.poll.questions[this.idx]);
    this.response.answers = [];
    const answerId = this.pageAnswer.answerOrder - 1;
    this.response.answers[0] = this.poll.questions[this.idx].answers[answerId];

    let parameters = {
      'questionId': this.response.id,
      'answerId': this.response.answers[0].id
    }
    this.hashMapQuestions[this.response.orderquestion] = this.response;
    this.hashMapQuestionsAnswers[this.response.orderquestion] = parameters;

    this.listquestion = Object.values(this.hashMapQuestions);
    //const qrs = Object.values(this.hashMapQuestionsAnswers);
    //console.log(qrs);


    if (this.poll.questions[this.idx].answers[answerId].breakpoll) {
      this.idx = undefined;
      this.calculateProgress(this.poll.questions.length);
    } else {
      this.idx = this.response.answers[0].nextquestion - 1; //posicion en array
      //this.id_prev_question = this.response.answers[0].prevquestion;
      this.id_prev_question = this.pageAnswer.questionOrder;
      this.listDisabledAnswers = this.response.answers[0].disabledanswers.split(",");
      this.calculateProgress(this.pageAnswer.questionOrder);
    }
  }

  calculateProgress(pos: number) {
    this.progress = (pos * 100) / this.poll.questions.length;
  }

  onResetQuestion() {
    this.idx = 0;
    this.hashMapQuestions = {};
    this.hashMapQuestionsAnswers = {};
    this.listDisabledAnswers = [];
    this.calculateProgress(1);
  }

  onBackQuestion(event: CustomEvent<number>) {
    window.scrollTo(0, 0);
    this.idx = event.detail - 1;
    this.listDisabledAnswers = [];
    this.calculateProgress(this.idx);
  }

  onSendToSummary() {
    window.scrollTo(0, 0);
    this.idx = undefined;
    this.calculateProgress(this.poll.questions.length);
}

  onSendQuestion(event: CustomEvent<Data>) {
    //console.log(event.detail['email']);

    const questionsanswers = Object.values(this.hashMapQuestionsAnswers);
    let parameters = {
      'codeOrigin': this.origin,
      'codeCountry': this.country,
      'pollId': this.poll.id,
      'pollType': this.type,
      'email': event.detail['email'],
      'user': event.detail['user'],
      'habeas': event.detail['data'] === '1' ? true : false,
      'questionsAnswers': questionsanswers
    }

    fetch(`${process.env.SERVICES_API}/reference`, {
      method: 'POST',
      body: JSON.stringify(parameters),
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Basic ${process.env.SERVICES_TOKEN}`
      }
    }).then(res => res.json()
    )
      .catch(error => console.error('Error:', error))
      .then(response => this.referencePoll.emit(response));
  }

  render() {
    return (
      <div class="u-padSides1 u-padEnds2">
        <div class="progress">
          <div id="ProgressBar" style={{ width: this.progress + '%' }}></div>
        </div>

        {this.poll.questions[this.idx] ? (
          <sg-question questions={this.poll.questions[this.idx]} buttonselect={this.poll.buttonselect} buttonback={this.poll.buttonback}
            buttonreset={this.viewanswers.buttonrepeatanswer}
            onNextQuestion={e => this.onNextQuestion(e)} onBackQuestion={b => this.onBackQuestion(b)} onResetQuestion={() => this.onResetQuestion()}
            onSendToSummary={() => this.onSendToSummary()} name={this.name} email={this.email} user={this.user} prevquestion={this.id_prev_question} disabledAnswers={this.listDisabledAnswers} textsMap={this.textsMap}></sg-question>
        ) :
          <sg-answers response={this.listquestion} onResetQuestion={() => this.onResetQuestion()} name={this.name} textsMap={this.textsMap} 
          email={this.email} user={this.user} viewanswers={this.viewanswers} onSendQuestion={(e) => this.onSendQuestion(e)}></sg-answers>
        }
      </div>
    );
  }
}

